import type { ReactNode } from 'react';

interface SectionCardProps {
  index: number;
  title: string;
  note?: string;
  children: ReactNode;
}

export default function SectionCard({ index, title, note, children }: SectionCardProps) {
  return (
    <section className="bg-background-50 rounded-xl border border-secondary-200/70 p-4 md:p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-xs font-semibold shrink-0">
          {index}
        </span>
        <h2 className="text-base font-semibold text-primary-600">{title}</h2>
      </div>
      {note ? (
        <p className="text-xs text-foreground-400 leading-relaxed -mt-2 mb-4">{note}</p>
      ) : null}
      <div className="space-y-5">{children}</div>
    </section>
  );
}